import { classNames } from "primereact/utils";
import { dateUtility } from "../../../../common/infrastructure/utilities/dateUtility";
import { MessageStatus } from "../emailLogs/models/emailLogModel";
import { StatusChip } from "./StatusChip";
import styles from "./CommunicationLogItem.module.scss";

interface ICommunicationLogItemProps {
  className?: string;
  index: number;
  receiverName?: string;
  /** Who or what it went to: the email address, the phone number, the kind of notification. */
  receiver: string;
  /** The second line: the subject, the SMS text, the notification text. */
  details?: string | null;
  status: MessageStatus;
  createdOn: string;
  onClick?: () => void;
}

/** One row of the email, SMS or device-notification log. */
export const CommunicationLogItem = ({
  className,
  index,
  receiverName,
  receiver,
  details,
  status,
  createdOn,
  onClick,
}: ICommunicationLogItemProps) => (
  <div className={classNames(styles.root, className)} onClick={onClick}>
    <div className={styles.root_index}>{index}</div>
    <div className={styles.root_main}>
      <div className={styles.root_main_receiver}>
        {receiverName && <span>{receiverName}</span>}
        {receiverName && <span className={styles.root_main_dot}>•</span>}
        <span>{receiver}</span>
      </div>
      {details && <div className={styles.root_main_details}>{details}</div>}
    </div>
    <div className={styles.root_right}>
      <StatusChip status={status} />
      <div className={styles.root_right_date}>{dateUtility.formatDateTime(createdOn)}</div>
    </div>
  </div>
);
